import { Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

export default function TimflowSummaryGrid({
  rows,
  title,
}: Readonly<{ rows: Record<string, unknown>[]; title?: string }>) {
  const { t } = useTranslation();

  if (!rows?.length) return null;

  const formatValue = (key: string, v: unknown) => {
    if (key === "layerType" && typeof v === "string") {
      return t(`calculations.methods.timflow.layer-types.${v}`, {
        defaultValue: v,
      });
    }
    if (typeof v === "number")
      return v.toLocaleString(undefined, { maximumFractionDigits: 4 });
    if (v !== null && typeof v === "object") return JSON.stringify(v);
    return String(v ?? "-");
  };

  const columns: GridColDef[] = Object.keys(rows[0]).map((key) => ({
    field: key,
    headerName: t(`calculations.methods.timflow.fields.${key}`, {
      defaultValue: key,
    }),
    flex: 1,
    minWidth: 120,
    sortable: false,
    valueFormatter: (v: unknown) => formatValue(key, v),
  }));

  return (
    <Stack spacing={1}>
      {title && <Typography variant="h6">{title}</Typography>}
      <DataGrid
        rows={rows.map((r, i) => ({ ...r, id: i }))}
        columns={columns}
        hideFooter
        disableColumnMenu
        sx={{ boxShadow: 1 }}
      />
    </Stack>
  );
}